module.exports = "/images/Layer_3.svg?cdd3e66dc61862633117d7d2e9ec434b";